<ecu-dialog
  primaryButtonColor="warn"
  [primaryButtonLabel]="data.primaryButtonLabel ?? 'globals.delete'"
  [secondaryButtonLabel]="data.secondaryButtonLabel ?? 'popup.cancel'"
  [isPrimaryButtonLoading]="isLoading"
  (primaryButtonClick)="delete()"
  (secondaryButtonClick)="cancel()"
>
  {{ description | translate }}
</ecu-dialog>
